import { Link } from "react-router-dom";

interface EmptyStateProps {
  title: string;
  description: string;
  onReset?: () => void;
  resetLabel?: string;
  icon?: string;
}

export default function EmptyState({ title, description, onReset, resetLabel = "重置筛选", icon = "ri-inbox-line" }: EmptyStateProps) {
  return (
    <div className="w-full rounded-lg border border-background-300/50 bg-background-100/60 px-6 py-16 flex flex-col items-center text-center">
      <div className="w-14 h-14 rounded-full bg-background-200/70 flex items-center justify-center mb-4">
        <i className={`${icon} text-2xl text-accent-500`} />
      </div>
      <h3 className="font-heading text-lg text-foreground-900">{title}</h3>
      <p className="mt-2 text-sm text-foreground-500 max-w-md leading-relaxed">{description}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="h-9 px-4 rounded-md bg-primary-600 hover:bg-primary-500 text-foreground-950 text-xs transition-colors cursor-pointer whitespace-nowrap"
          >
            {resetLabel}
          </button>
        )}
        <Link
          to="/popular"
          className="h-9 px-4 rounded-md border border-background-300/70 text-foreground-600 hover:text-accent-400 hover:border-accent-600/60 text-xs flex items-center transition-colors whitespace-nowrap"
        >
          看看热门推荐
        </Link>
      </div>
    </div>
  );
}